import { RJSFSchema } from '@rjsf/utils'
import { getPayloadUiSchema, SchemaWidget, SchemaWidgets } from './schema-utils'
import {
  CalendarBlankIcon,
  UserIcon,
  ToggleLeftIcon,
  FileTextIcon,
  KeyboardIcon
} from 'prove-common'
import { ExternalReferenceField } from '../components/form/fields/ExternalReferenceField'
import { SelectDueDateWidget } from '../components/form/widgets/SelectDueDateWidget'

export const mainWidgets = (
  payloadSchema: RJSFSchema | undefined,
  isEditing: boolean,
  useLokalitetWidget = false,
  isPartiallyEditable: boolean = false
): SchemaWidgets => {
  const externalReferenceWidget: SchemaWidget = useLokalitetWidget
    ? {
        id: 'lokalitet',
        icon: <UserIcon />,
        propKey: 'lokalitet',
        schema: {
          $ref: '#/definitions/lokalitet'
        },
        uiSchema: {
          'ui:field': ExternalReferenceField,
          'ui:options': {
            externalReferenceType: 'LOKALITET'
          },
          'ui:label': true
        },
        isRequired: true,
        state: 'locked' as const
      }
    : {
        id: 'produsent',
        icon: <UserIcon />,
        propKey: 'produsent',
        schema: {
          $ref: '#/definitions/produsent'
        },
        uiSchema: {
          'ui:field': ExternalReferenceField,
          'ui:options': {
            externalReferenceType: 'PRODUSENT'
          },
          'ui:label': true
        },
        isRequired: true,
        state: 'locked'
      }

  return [
    {
      id: 'takenDate',
      icon: <CalendarBlankIcon />,
      propKey: 'takenDate',
      schema: {
        $ref: '#/definitions/takenDate'
      },
      uiSchema: {
        'ui:disabled': isPartiallyEditable,
        'ui:widget': SelectDueDateWidget
      },
      isRequired: true,
      state: 'locked'
    },
    externalReferenceWidget,
    {
      id: 'nameRedacted',
      icon: <ToggleLeftIcon />,
      propKey: 'nameRedacted',
      schema: {
        $ref: '#/definitions/nameRedacted'
      },
      uiSchema: {
        'ui:widget': 'radio',
        'ui:disabled': isPartiallyEditable ? !isPartiallyEditable : isEditing
      },
      isRequired: true,
      state: 'locked'
    },
    {
      id: 'payload',
      icon: <FileTextIcon />,
      propKey: 'payload',
      schema: payloadSchema,
      uiSchema: {
        ...getPayloadUiSchema(payloadSchema),
        'ui:disabled': isPartiallyEditable
      },
      isRequired: payloadSchema != null,
      state: 'hidden'
    },
    {
      id: 'comment',
      icon: <KeyboardIcon />,
      propKey: 'comment',
      schema: {
        $ref: '#/definitions/comment'
      },
      uiSchema: {
        'ui:widget': 'markdownEditorWidget',
        'ui:placeholder': 'Skriv en kommentar...',
        'ui:options': {
          charLimit: 1000
        }
      },
      isRequired: false,
      state: 'locked'
    }
  ]
}
